// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"IngredientsDecision_closeIcon__G_kiC"};